import { normalizeField, parseInteger, ensureArray, ensureString } from '../base/BaseNormalizer';
import {
  validateAssociatedWorkkardResponse,
  validateAssociatedWorkkardFilterResponse,
} from './validateNormalization';

export const normalizeAssociatedWorkkardItem = (raw = {}) => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  return {
    ...raw,
    WkId: normalizeField(raw, ['WkId'], null),
    WkNumber: ensureString(normalizeField(raw, ['WkNumber'], '')),
    WkStatus: ensureString(normalizeField(raw, ['WkStatus'], '')),
    SponsorId: normalizeField(raw, ['SponsorId'], null),
    SponsorName: ensureString(normalizeField(raw, ['SponsorName'], '')),
    TemplateType: ensureString(normalizeField(raw, ['TemplateType'], '')),
    IsViewable: normalizeField(raw, ['IsViewable'], true),
    FieldKey: normalizeField(raw, ['FieldKey'], null),
    FieldValue: normalizeField(raw, ['FieldValue'], null),
    DynamicFields: normalizeField(raw, ['DynamicFields'], {}),
  };
};

export const normalizeAssociatedWorkkardResponse = (response, requestPayload = {}) => {
  if (!response || typeof response !== 'object') {
    return {
      Data: [],
      Total: 0,
      FilterValue: '',
      take: requestPayload.take,
      skip: requestPayload.skip,
      rows: requestPayload.row,
    };
  }

  validateAssociatedWorkkardResponse(response);

  const listData = ensureArray(normalizeField(response, ['Data'], []));

  return {
    Data: listData.map(normalizeAssociatedWorkkardItem).filter(Boolean),
    Total: parseInteger(normalizeField(response, ['Total'], 0), 0),
    FilterValue: ensureString(normalizeField(response, ['FilterValue'], '')),
    take: normalizeField(response, ['take'], requestPayload.take),
    skip: normalizeField(response, ['skip'], requestPayload.skip),
    rows: normalizeField(response, ['rows'], requestPayload.row),
  };
};

export const normalizeAssociatedWorkkardFilterResponse = (response) => {
  if (!response || typeof response !== 'object') {
    return { Data: [], Filter: [] };
  }

  validateAssociatedWorkkardFilterResponse(response);

  return {
    Data: ensureArray(normalizeField(response, ['Data'], [])),
    Filter: ensureArray(normalizeField(response, ['Filter'], [])),
  };
};

export const normalizeContactInsuredResponse = (raw) => {
  if (!raw || typeof raw !== 'object') {
    return {};
  }
  return { ...raw };
};
